import { useEffect } from "react";
import { useSelector } from "react-redux";
import Accordion from "react-bootstrap/esm/Accordion";
import Card from "react-bootstrap/esm/Card";
import { useAppDispatch, RootState } from "../../../redux/store";
import { retrieveAccordionProfile } from "../../../redux/slice/accordion-profile-slice";

const AccordionProfileSlice = (props: { path: string }) => {
  const dispatch = useAppDispatch();
  const { AccordionProfileData } = useSelector((state: RootState) => state.AccordionProfile);

  useEffect(() => {
    dispatch(retrieveAccordionProfile(`${props.path}%2FProfile-Items`));
  }, [dispatch])

  return (
    <>
      {AccordionProfileData[0]?.data.length > 0 &&
        <div className="container">
          <Accordion flush className='convergence'>
            {AccordionProfileData[0]?.data?.map((item, index) => {
              return <Card className='m-0'>
                <Accordion.Item eventKey={index.toString()} key={index}>
                  <Card.Header>
                    <Accordion.Header className="btn btn-block heading">
                      <span dangerouslySetInnerHTML={{ __html: item.name }}></span>
                      <i aria-hidden="true" className="fa fa-angle-double-down" id="fa-angle-arrow"></i>
                    </Accordion.Header>
                  </Card.Header>
                  <Accordion.Body dangerouslySetInnerHTML={{ __html: item.description }}></Accordion.Body>
                </Accordion.Item>
              </Card>
            })}
          </Accordion>
          <div>&nbsp;</div>
        </div>}
    </>
  )
};

export default AccordionProfileSlice;